module.exports = (__webpack_require__(0))(405)


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/core-js/modules/es6.object.is-frozen.js from dll-reference polyfills_lib
// module id = 346
// module chunks = 2